import { Card, Stack, Text, TextInput } from '@mantine/core';
import { type UseFormReturnType } from '@mantine/form';
import { type CreateClient } from '@/schemas/API/POST/client/request';

interface ContactCardProps {
  formContext: () => UseFormReturnType<CreateClient>;
  disabled?: boolean;
}

export const ContactCard: React.FC<ContactCardProps> = (props) => {
  const form = props.formContext();

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Text fw={700} size="large">
        Kontaktní údaje
      </Text>
      <Stack gap="sm" className="mt-3">
        <TextInput
          variant="filled"
          radius="md"
          label="Telefon"
          {...form.getInputProps('phone')}
          disabled={props.disabled}
        />
        <TextInput
          variant="filled"
          radius="md"
          label="E-mail"
          {...form.getInputProps('email')}
          disabled={props.disabled}
        />
      </Stack>
    </Card>
  );
};
